import { STACK } from "../../data/portfolio";
import { Heading } from "./Primitives";

export default function StackOutput() {
  return (
    <div>
      <Heading>cat stack.json</Heading>
      <div className="space-y-1.5">
        {Object.entries(STACK).map(([category, items]) => (
          <div key={category} className="flex gap-3">
            <span className="text-sky-400 w-24 shrink-0">{category}:</span>
            <span className="text-neutral-200">{items.join(", ")}</span>
          </div>
        ))}
      </div>
    </div>
  );
}